<!--

   V 0.1.0 - 2022-08-22

 -->
<template>
  <div>
    <v-container>
      <div>
        <v-card class="mx-auto text-h4">
          <v-card-title class="text-h4">
            <v-btn
              class="mx-2"
              fab
              dark
              color="indigo"
              :to="`/vehicle-select/car-battery/0/Battery`"

            >
              <v-icon dark> mdi-arrow-left-circle </v-icon>
            </v-btn>

            <v-divider class="mx-4" vertical></v-divider>

            14- Day Battery Graph

            <v-divider class="mx-4" vertical></v-divider>
          </v-card-title>

          <v-progress-linear
            v-if="isLoading"
            indeterminate
            color="cyan "
          ></v-progress-linear>
        </v-card>

        <v-row no-gutters>
          <v-col>
            <DatePick lg="12" md="6" sm="12" v-model="pickerDate" />
          </v-col>
          <v-col>
            <div class="text-h4 elevation-2 px-6 py-3 my-1">
              Vehicle: {{ VehicleReg }}
            </div>
          </v-col>
        </v-row>
      </div>

      <div>
        <BatteryChart
          :UnitModel2ID="UnitModel2ID"
          :startTime="pickerDate"
          :UnitID="UnitID"
          @loading="loadingResult"
        />
      </div>
    </v-container>
  </div>
</template>

<script>
import BatteryChart from './CarBattery2.vue'

import { format, parseISO, addDays } from 'date-fns'

import DatePick from '@/lib/v1/comp/DatePick'

export default {
  components: {
    DatePick,
    BatteryChart
  },

  data () {
    return {
      UnitModel2ID: 0,

      isLoading: false,
      //
      VehicleReg: '',

      UnitID: '',

      pickerDate: format(
        parseISO(addDays(new Date(), 0).toISOString()),
        'yyyy-MM-dd'
      )
    }
  },

  methods: {
    loadingResult (loadingState) {
      this.isLoading = loadingState
    }
  },

  mounted () {
    this.UnitID = this.$route.params.UnitID
    this.VehicleReg = this.$route.params.VehicleReg

    if (this.$debug) {
      console.log(this.UnitID)
    }
  },

  created () {
    this.VehicleReg = this.$route.params.VehicleReg
    this.UnitID = this.$route.params.UnitID

    this.date = this.$route.params.dayDate
    this.VehicleID = this.$route.params.VehicleID

    if (this.$route.params.UnitModel2ID) {
      this.UnitModel2ID = parseInt(this.$route.params.UnitModel2ID)
    }

    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        if (this.$debug) {
          console.log('toParams:')
          console.log(toParams)
          console.log(previousParams)
        }

        this.VehicleReg = this.$route.params.VehicleReg
        this.UnitID = this.$route.params.UnitID

        if (this.$route.params.UnitModel2ID) {
          this.UnitModel2ID = parseInt(this.$route.params.UnitModel2ID)
        }
      }

    )
  } // created()
}
</script>
